import { lazy } from 'react';

const Overview = lazy(() => import('./Overview'));

export { Overview };